﻿import * as MessageBarservice from "../core/services/messageBarService/messageBar.service";

export class AdministrationFrameController {
    public showMessage: boolean = false;
    public messageStyle: string = "alert alert-info";
    public doFade: boolean = false;
    public message: string = "";

    public static $inject = ["messageBarService", "$timeout", "$state"];

    public constructor(public messageBarService: MessageBarservice.MessageBarService,
        public $timeout: ng.ITimeoutService,
        private $state: ng.ui.IStateService
    ) {
        //event handlers
        this.messageBarService.listen(this.setMessageStatus);
    }

    public navigate(to: string){
        switch (to.toLowerCase()){
            case "search":
                this.$state.go("shellFrame.administrationFrame.search");
                break;           
            case "eventlog":
                this.$state.go("shellFrame.administrationFrame.eventLog");
                break;
            case "paymentsearch":
                this.$state.go("shellFrame.administrationFrame.paymentSearch");
                break;
            case "paymentsearchbystatement":
                this.$state.go("shellFrame.administrationFrame.paymentSearchByStatement");
                break;
            case "paymentmethodsearch":
                this.$state.go("shellFrame.administrationFrame.paymentMethodSearch");
                break;
            case "clientstatecontextsearch":
                this.$state.go("shellFrame.administrationFrame.clientstatecontextsearch");
                break;
        }
    }



    
   
    //(this.) was losing scope notice the notice the implementation with implicit signature and correct lexical scope below
    //I was not able to set the fields at the class level until I implemented my function this way.
    //(1)http://stackoverflow.com/questions/14471975/how-can-i-preserve-lexical-scope-in-typescript-with-a-callback-function
    public setMessageStatus = (event: any, args: any) => {
        this.showMessage = false;
        this.doFade = false;
        this.message = args.message;

        switch (args.messageType as MessageBarservice.MessageType) {
        case MessageBarservice.MessageType.Danger:
            this.messageStyle = "alert alert-danger";
            break;
        case MessageBarservice.MessageType.Info:
            this.messageStyle = "alert alert-info";
            break;
        case MessageBarservice.MessageType.Warning:
            this.messageStyle = "alert alert-warning";
            break;
        default:
            this.messageStyle = "alert alert-info";
        }

        this.showMessage = true;

        //again lexical scope keeps (this.) to the scope of the class
        this.$timeout(() => { this.doFade = true; }, 1600);
    }
}